
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h13.406l.313.281 6 6 .281.313V29H5V3zm2 2v22h16V11h-6V5H7zm12 1.438v2.563h2.563zm-7 6.781l1.5.938 5 3 1.438.844-1.438.844-5 3-1.5.938V13.22zm2 3.531v2.5L16.094 18z"}})])
          )
        }
      }
    